module.exports = __webpack_public_path__ + "img/WuDaJiang_EGM.832e329c.png";